import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import { catalogGuideRouteRef, organizationRouteRef } from './routes';

const organizationPage = PageBlueprint.make({
  name: 'organization',
  params: {
    path: '/organization',
    routeRef: organizationRouteRef,
    title: 'Organization',
    icon: <AccountTreeIcon />,
    noHeader: true,
    loader: async () => {
      const { OrganizationPage } = await import('./VerticalPages');
      return <OrganizationPage />;
    },
  },
});

const catalogGuidePage = PageBlueprint.make({
  name: 'catalog-guide',
  params: {
    path: '/catalog-guide',
    routeRef: catalogGuideRouteRef,
    title: 'Catalog Guide',
    icon: <MenuBookOutlinedIcon />,
    noHeader: true,
    loader: async () => {
      const { CatalogGuidePage } = await import('./CatalogGuidePage');
      return <CatalogGuidePage />;
    },
  },
});

const functionContextCard = EntityCardBlueprint.make({
  name: 'function-context',
  params: {
    type: 'info',
    filter: { kind: 'function' },
    loader: async () => {
      const { FunctionContextCard } = await import('./FunctionCards');
      return <FunctionContextCard />;
    },
  },
});

const functionRelationsCard = EntityCardBlueprint.make({
  name: 'function-relations',
  params: {
    type: 'content',
    filter: { kind: 'function' },
    loader: async () => {
      const { FunctionRelationsCard } = await import('./FunctionCards');
      return <FunctionRelationsCard />;
    },
  },
});

const verticalContextCard = EntityCardBlueprint.make({
  name: 'vertical-context',
  params: {
    type: 'info',
    filter: { kind: 'group', 'spec.type': 'vertical' },
    loader: async () => {
      const { VerticalContextCard } = await import('./VerticalPages');
      return <VerticalContextCard />;
    },
  },
});

const verticalDiscoveryCard = EntityCardBlueprint.make({
  name: 'vertical-discovery',
  params: {
    type: 'content',
    filter: { kind: 'group', 'spec.type': 'vertical' },
    loader: async () => {
      const { VerticalDiscoveryCard } = await import('./VerticalPages');
      return <VerticalDiscoveryCard />;
    },
  },
});

export const operatingModelPlugin = createFrontendPlugin({
  pluginId: 'operating-model',
  routes: {
    organization: organizationRouteRef,
    catalogGuide: catalogGuideRouteRef,
  },
  extensions: [
    organizationPage,
    catalogGuidePage,
    functionContextCard,
    functionRelationsCard,
    verticalContextCard,
    verticalDiscoveryCard,
  ],
});
